import { useNavigate } from "react-router-dom";
import { STICKERS } from "../../assets/media/stickers";
import TgSticker from "../sticker/TgSticker";
import "./LogoutDialog.scss";

function LogoutDialog({ setIsOpen, setIsRendering }) {
    const navigate = useNavigate();

    const onCloseClick = () => {
        setIsRendering(true);
        setIsOpen(false);
    }

    const onClickYes = () => {
        onCloseClick();
        setTimeout(() => {
            localStorage.removeItem("Token");
            localStorage.removeItem("User-Id");
            navigate("/login");
        }, 150)
    }

    return (
        <div className="logout-wrapper">
            <div className="sticker">
                <TgSticker src={STICKERS.duck_open} />
            </div>

            <div className="logout-text-block">
                <div className="title">Вы уверены, что хотите выйти из аккаунта?</div>
                <div className="text">Для повторного входа снова потребуются ваш логин и пароль.</div>
            </div>

            <div className="logout-buttons-block">
                <div className="button yes" onClick={onClickYes}>Да, выйти</div>
                <div className="button no" onClick={onCloseClick}>Нет, остаться</div>
            </div>
        </div>
    )
};

export default LogoutDialog;